module.exports = __webpack_public_path__ + "img/button5.8f09814d.png";